export const consoleInfo = (msg: any): void => {
  console.info(msg);
};

export const consoleError = (msg: any): void => {
  console.error(msg);
};
